module.exports = __webpack_public_path__ + "assets/d168c77d6968d838f8ad35fcc3ea2d00.mp3";